'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v8.863l3.684-5.192 1.632 1.158-5.28 7.439A1 1 0 0 0 3 19h18a1 1 0 0 0 .964-.732l-5.28-7.44 1.631-1.157L22 14.863V6a1 1 0 0 0-1-1z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="m1.611 5.209 9.778 7.555a1 1 0 0 0 1.222 0l9.778-7.555L23.61 6.79l-9.777 7.555a3 3 0 0 1-3.668 0L.389 6.791z" clipRule="evenodd" /></svg>;
const IconEmail = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconEmail;